@if (dataName && dataValue) {
  <div class="flex flex-row items-end gap-x-10">
    <span [class]="config?.dataNameClass" class="flex-none">{{dataName}}</span>
    <span class="border-b border-dotted border-gray-lighter flex-grow"></span>
    <span [class]="config?.dataValueClass" class="flex-none text-right font-bold">{{dataValue}}</span>
  </div>
}